export enum CountryCode {
  Unknown = '',
  Austria = 'at',
  Belgium = 'be',
  Bulgaria = 'bg',
  Croatia = 'hr',
  Cyprus = 'cy',
  CzechRepublic = 'cz',
  Denmark = 'dk',
  Estonia = 'ee',
  Finland = 'fi',
  France = 'fr',
  Germany = 'de',
  Greece = 'gr',
  Hungary = 'hu',
  Iceland = 'is',
  Ireland = 'ie',
  Italy = 'it',
  Latvia = 'lv',
  Liechtenstein = 'li',
  Lithuania = 'lt',
  Luxembourg = 'lu',
  Malta = 'mt',
  Netherlands = 'nl',
  Norway = 'no',
  Poland = 'pl',
  Portugal = 'pt',
  Romania = 'ro',
  Slovakia = 'sk',
  Slovenia = 'sl',
  Spain = 'es',
  Sweden = 'se',
  Switzerland = 'ch',
  UnitedKingdom = 'uk'
}

export const countryCodeMap = new Map<string, CountryCode>();
Object.keys(CountryCode).forEach((countryCode: CountryCode) => {
    const modeValue: string = CountryCode[countryCode];
    countryCodeMap.set(modeValue, countryCode);
});


// WEBPACK FOOTER //
// ./src/types/tenants/country-code.ts